<template>
  <div :class="[this.$store.state.isMobile ? 'home2' : 'home1']">
    <navbar ref="navBarVue"></navbar>
    <div class="home-page" @click="closeNav">
      <!-- 轮播 -->
      <div class="lunbo">
        <!-- <el-carousel trigger="click" height="100%" arrow="always">
          <el-carousel-item v-for="(item, index) in slideList" :key="index">
            <el-image
              :src="baseUrl + item.path"
              fit="cover"
              style="width: 100%; height: 100%"
            >
            </el-image>
            <div class="banner-lunbo">
              <div>
                <div class="bold-txt">
                  <span>{{ item.name }}</span>
                </div>

                <div class="thin-txt">
                  <span>{{ item.remarks }}</span>
                </div>
                <div class="btn">更多详情</div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel> -->
        <swiper
          :options="swiperOption"
          ref="mySwiper"
          class="swiper-container"
          v-if="slideList.length > 0"
        >
          <swiper-slide v-for="(item, index) in slideList" :key="index">
            <img
              v-show="!isMobile"
              :src="baseUrl + item.productPath"
              style="object-fit: cover; width: 100%; height: 100%;cursor: pointer;"
              @click.stop="goDetail(item.pageCategory, item.id)"
            />
            <img
              v-show="isMobile"
              :src="baseUrl + item.productMobilePath"
              style="object-fit: cover; width: 100%; height: 100%;cursor: pointer;"
              @click.stop="goDetail(item.pageCategory, item.id)"
            />
            <!-- <div class="banner-lunbo">
              <div>
                <div class="bold-txt">
                  <span>{{ item.name }}</span>
                </div>

                <div class="thin-txt">
                  <span>{{ item.remarks }}</span>
                </div>
                <div class="btn">更多详情</div>
              </div>
            </div> -->
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <!-- 箭头 -->
          <div
            class="swiper-button-prev"
            slot="button-prev"
            v-show="!this.$store.state.isMobile"
          ></div>
          <div
            class="swiper-button-next"
            slot="button-next"
            v-show="!this.$store.state.isMobile"
          ></div>
        </swiper>
      </div>
      <!-- 推荐信息 -->
      <div class="product-box">
        <div class="mol-header center-header">
          <div class="title">
            <span>推荐信息</span>
          </div>
          <div class="line"></div>
        </div>
        <div class="content">
          <div class="row">
            <el-col
              v-for="(item, index) in recommendData"
              :key="index"
              :span="index == 0 || index == 3 ? 16 : 8"
            >
              <div
                :class="[
                  index == 0 || index == 3 ? 'col1 imgBox' : 'col2 imgBox',
                ]"
                @click="goDetail(item.pageCategory, item.id)"
              >
                <el-image
                  :src="baseUrl + item.productPath"
                  fit="cover"
                  style="width: 100%; height: 100%"
                  lazy
                >
                </el-image>
                <div class="imgDesc">
                  <div class="title">
                    <span>{{ item.productName }}</span>
                  </div>
                  <div class="pro-desc">
                    <span>{{ item.productOverview }}</span>
                  </div>
                  <div class="know-more">
                    <span>了解更多 ></span>
                  </div>
                </div>
              </div>
            </el-col>

            <!-- <div class="col2 imgBox">
              <el-image
                :src="recommendData[1].path"
                fit="cover"
                style="width: 100%; height: 100%"
                lazy
              >
              </el-image>
            </div> -->
          </div>
          <!-- <div class="row">
            <div class="col2 imgBox">
              <el-image
                :src="recommendData[2].path"
                fit="cover"
                style="width: 100%; height: 100%"
                lazy
              >
              </el-image>
            </div>
            <div class="col1 imgBox">
              <el-image
                :src="recommendData[3].path"
                fit="cover"
                style="width: 100%; height: 100%"
                lazy
              >
              </el-image>
            </div>
          </div> -->
        </div>
      </div>

      <!-- 化工安全监管平台 -->
      <div class="product-box">
        <div class="mol-header left-header">
          <div class="title">
            <span>化工安全监管平台</span>
          </div>
        </div>
        <div class="content">
          <!-- <div class="row">
            <el-col :span="4" v-for="(item, index) in keynoteList" :key="index">
              <div
                class="col imgBox"
                @click="goDetail(item.pageCategory, item.id)"
              >
                <el-image
                  :src="baseUrl + item.productPath"
                  fit="cover"
                  style="width: 100%; height: 100%"
                  lazy
                >
                </el-image>
                <div class="norDesc">
                  <span>{{ item.productName }}</span>
                </div>
              </div>
            </el-col>
          </div> -->
          <el-tabs v-model="activeName" @tab-click="handleClick" :stretch="true">
            <el-tab-pane v-for="(item, index) in keynoteList" :key="index" :label="item.productTitle" :name="index.toString()" :lazy="true">
              <div
                class="imgBox tab-imgBox"
                style="height: 32rem;margin-top: 1rem;"
              >
                <el-image
                  :src="baseUrl + item.productPath"
                  fit="cover"
                  style="width: 100%; height: 100%"
                  lazy
                >
                </el-image>
                <div class="norDesc">
                  <div class="bold-txt">
                      <span>{{ item.productName }}</span>
                    </div>
                    <div class="thin-txt">
                      <span
                        >{{ item.productOverview}}</span
                      >
                    </div>
                    <div class="btn" @click="goDetail(item.pageCategory, item.id)">了解更多</div>
                </div>
              </div>
            </el-tab-pane>

          </el-tabs>
        </div>
      </div>
      <!-- 移动端 -->
      <div class="product-box1">
        <div class="mol-header center-header">
          <div class="title">
            <span>推荐信息</span>
          </div>
          <div class="line"></div>
        </div>
        <div class="content">
          <div class="lunbo2">
            <!-- <el-carousel
              trigger="click"
              height="100%"
              arrow="never"
              :autoplay="false"
            >
              <el-carousel-item
                v-for="(item, index) in recommendData"
                :key="index"
              >
                <el-image
                  :src="baseUrl + item.productPath"
                  fit="cover"
                  style="width: 100%; height: 100%"
                >
                </el-image>
                <div class="imgDesc">
                  <div class="title">
                    <span>{{ item.productName }}</span>
                  </div>
                  <div>
                    <span>{{ item.productOverview }}</span>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel> -->
            <swiper
              :options="swiperOption1"
              ref="mySwiper"
              class="swiper-container"
            >
              <swiper-slide v-for="(item, index) in recommendData" :key="index">
                <el-image
                  :src="baseUrl + item.productMobilePath"
                  fit="cover"
                  style="width: 100%; height: 100%"
                  @click="goDetail(item.pageCategory, item.id)"
                >
                </el-image>
                <div class="imgDesc">
                  <div class="title">
                    <span>{{ item.productName }}</span>
                  </div>
                  <div>
                    <span>{{ item.productOverview }}</span>
                  </div>
                  <!-- <div class="know-more">
                    <span>了解更多 ></span>
                  </div> -->
                </div>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
          <div class="row">
            <el-col :span="8" v-for="(item, index) in keynoteList" :key="index">
              <div
                class="col imgBox"
                @click="goDetail(item.pageCategory, item.id)"
              >
                <el-image
                  :src="baseUrl + item.productMobilePath"
                  fit="cover"
                  style="width: 100%; height: 100%"
                  lazy
                >
                </el-image>
                <!-- <div class="norDesc">
                  <span>{{ item.productName }}</span>
                </div> -->
              </div>
            </el-col>
          </div>
        </div>
      </div>

      <!-- banner -->
      <div class="body-banner" v-if="showImg.length > 0">
        <el-image
          v-show="!this.$store.state.isMobile"
          :src="baseUrl + showImg[0].productPath"
          fit="cover"
          lazy
          style="width: 100%; height: 100%"
        ></el-image>
        <el-image
          v-show="this.$store.state.isMobile"
          :src="baseUrl + showImg[0].productMobilePath"
          fit="cover"
          lazy
          style="width: 100%; height: 100%"
          @click="goDetail(showImg[0].pageCategory, showImg[0].id)"
        ></el-image>
        <div class="banner-text"  v-show="!this.$store.state.isMobile">
          <div>
            <div class="bold-txt">
              <span>{{ showImg[0].productName }}</span>
            </div>
            <!-- <div class="bold-txt">
              <span>助力企业全面实现降本增效</span>
            </div> -->
            <div class="line"></div>
            <div class="thin-txt">
              <span
                >{{ showImg[0].productOverview}}</span
              >
            </div>
            <div class="btn" @click="goDetail(showImg[0].pageCategory, showImg[0].id)">了解更多</div>
          </div>
        </div>
      </div>
      <!-- 新闻与活动 -->
      <div class="product-box">
        <div class="mol-header center-header">
          <div class="title">
            <span>新闻与活动</span>
          </div>
          <div class="line"></div>
        </div>
        <div class="content">
          <div class="row">
            <el-row :gutter="20">
              <el-col
                :span="8"
                v-for="(item, index) in eventsList"
                :key="index"
              >
                <div class="col3" @click="goDetail(4, item.id)">
                  <div class="top-tip">活动</div>
                  <div class="pic imgBox">
                    <el-image :src="baseUrl + item.path" fit="cover" style="height: 100%;"></el-image>
                  </div>
                  <div class="desc">
                    <div class="desc-title">
                      <span>{{ item.newsTitle }}</span>
                    </div>
                    <div class="desc-info">
                      <div>
                        <span>{{ item.source }}</span>
                      </div>
                      <div class="info-time">
                        <span>{{ getFormatDate(item.releaseTime) }}</span>
                      </div>
                    </div>
                    <div class="desc-end">
                      <span>{{ item.introduction }}</span>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="col3">
                  <div class="top-tip">新闻</div>
                  <div class="news-list">
                    <!-- <vue-scroll :ops="ops" style="height: 100%"> -->
                      <div
                        class="news-item"
                        v-for="(item, index) in newsList"
                        :key="index"
                        @click="goDetail(3, item.id)"
                      >
                        <div class="news-title">
                          <span>{{ item.newsTitle }} </span>
                        </div>
                        <div class="news-time">
                          <span>{{ getFormatDate(item.releaseTime) }}</span>
                        </div>
                      </div>
                    <!-- </vue-scroll> -->
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="product-box1">
        <div class="mol-header center-header">
          <div class="title">
            <span>新闻与活动</span>
          </div>
          <div class="line"></div>
        </div>
        <div class="content">
          <div class="row">
            <el-row :gutter="20">
              <el-col
                :span="24"
                v-for="(item, index) in eventsList"
                :key="index"
              >
                <div class="col3" @click="goDetail(4, item.id)">
                  <div class="top-tip">活动</div>
                  <div class="pic imgBox">
                    <el-image :src="baseUrl + item.path" fit="cover" style="height: 100%;"></el-image>
                  </div>
                  <div class="desc">
                    <div class="desc-title">
                      <span>{{ item.newsTitle }}</span>
                    </div>
                    <div class="desc-info">
                      <div>
                        <span>{{ item.source }}</span>
                      </div>
                      <div class="info-time">
                        <span>{{ getFormatDate(item.releaseTime) }}</span>
                      </div>
                    </div>
                    <div class="desc-end">
                      <span>{{ item.subtitle }}</span>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="col3 news-col">
                  <div class="top-tip">新闻</div>
                  <div class="news-list">
                    <!-- <vue-scroll :ops="ops" style="height: 100%"> -->
                      <div
                        class="news-item"
                        v-for="(item, index) in newsList"
                        :key="index"
                        @click="goDetail(3, item.id)"
                      >
                        <div class="news-title">
                          <span>{{ item.newsTitle }} </span>
                        </div>
                        <div class="news-time">
                          <span>{{ getFormatDate(item.releaseTime) }}</span>
                        </div>
                      </div>
                    <!-- </vue-scroll> -->
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <!-- 更多 -->
      <div class="more">
        <div class="more-btn" @click="goMoreActivity">
          <span>更多活动</span>
        </div>
        <div class="more-btn" @click="goMoreNews">
          <span>更多新闻</span>
        </div>
      </div>
    </div>
    <bottom-nav></bottom-nav>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";
import navbar from "@/components/navbar.vue";
import bottomNav from "@/components/bottomNav.vue";
import {
  getConfigKey,
  getSlideListData,
  getHomePageData,
} from "@/api/front.js";
import { format } from "date-fns";

// 引入swiper插件
import { swiper, swiperSlide } from "vue-awesome-swiper";

const baseURL = process.env.VUE_APP_BASE_API;
export default {
  name: "HomeView",
  components: {
    swiper,
    swiperSlide,
    navbar,
    bottomNav,
    HelloWorld,
  },

  data() {
    return {
      isMobile:this.$store.state.isMobile,
      activeName:'0',
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: true,
          disableOnInteraction: true,
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperOption1: {
        loop: false,
        autoplay: false,
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
      },
      baseUrl: baseURL,
      slideList: [],
      recommendData: [],
      keynoteList: [],
      newsList: [],
      eventsList: [],
      showImg: [],
      ops: {
        vuescroll: {
          mode: "native",
          sizeStrategy: "percent",
          detectResize: true,
          scroller: {
            maxZoom: 1,
            minZoom: 1,
          },
          locking: true,
        },
        bar: {
          background: "#dddddd",
          keepShow: true,
        },
        scrollPanel: {
          initialScrollY: false,
          initialScrollX: false,
          scrollingX: false,
          scrollingY: true,
          speed: 300,

          verticalNativeBarPos: "right",
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  created() {
    this.getHomePageData();
  },
  mounted() {
    this.getSlideData();
  },
  methods: {
    handleClick(){},
    getFormatDate(date) {
      return format(date, "yyyy年MM月dd日");
    },
    getSlideData() {
      getSlideListData().then((res) => {
        this.slideList = res.data;
      });
    },
    getHomePageData() {
      getHomePageData().then((res) => {
        this.recommendData = res.data.recommendList;
        this.eventsList = res.data.eventsList;
        this.keynoteList = res.data.keynoteList;
        this.newsList = res.data.newsList;
        this.showImg = res.data.showImg;
      });
    },
    goDetail(type, id) {
      let path = "";
      if (type == 0) {
        path = "/product-detail";
      } else if(type == 2){
        path = "/product-detail1";
      }
      else {
        path = "/article-detail";
      }
      let routerJump = this.$router.resolve({
        path: path,
        query: { id: id, category: type },
      });
      window.open(routerJump.href, "_blank");
    },
    goMoreActivity() {
      let routerJump = this.$router.resolve({
        path: '/dynamic-list',
        query: { category:'1' },
      });
      window.open(routerJump.href, "_blank");
    },
    goMoreNews() {
      let routerJump = this.$router.resolve({
        path: '/dynamic-list',
        query: { category:'0' },
      });
      window.open(routerJump.href, "_blank");
    },
    //关闭导航菜单
    closeNav(){
      console.log('关闭');

      this.$refs['navBarVue'].closeNavDetail()
    }
  },
};
</script>
<style lang="scss" scoped>
@import "swiper/dist/css/swiper.css";
// @media (min-width: 1200px) {
//   .product-box {
//     max-width: 1368px;
//   }
// }
// @media (max-width: 768px) {
//   .product-box {
//     max-width: 100%;
//   }
// }
::v-deep.el-tabs{
  width: 100%;
  .el-tabs__item{
    font-size: 1.4rem !important;
  }
}
::v-deep .el-tabs__item {
    font-size: 1.4rem;
    height: 4rem;
}

::v-deep .el-tabs__item:hover {
    color: #1774f5;
}

::v-deep .el-tabs__item.is-active {
    color: #1774f5;
}

::v-deep .el-tabs__active-bar {
    background-color: #1774f5;
}

::v-deep .el-pager li.active {
    color: #1774f5;
}
.home1 {
  min-height: calc(100vh - 36rem);
  padding-top: 6rem;
  padding-bottom: 30rem;
  position: relative;
  .home-page {
    width: 100%;
    margin: 0 auto;
    // min-width: 1440px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .lunbo {
      width: 100%;
      // height: 720px;
      height: 51rem;
      position: relative;
      margin-bottom: 2rem;
      .swiper-container {
        width: 100%;
        height: 100%;
      }
      .swiper-button-prev,
      .swiper-button-next {
        width: 2rem;
        height: 3rem;
        padding: 0 2rem;
      }
      .el-carousel {
        width: 100%;
        height: 100%;
      }
      .banner-lunbo {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        text-align: left;
        padding-top: 18rem;
        padding-left: 14rem;
        box-sizing: border-box;
        .bold-txt {
          font-weight: bold;
          font-size: 3rem;
        }
        .thin-txt {
          margin-top: 2.5rem;
          font-size: 1.6rem;
        }
        .line {
          width: 14rem;
          border: 0.15rem solid #1774f5;
          background-color: #1774f5;
          margin-top: 1.5rem;
        }
        .btn {
          cursor: pointer;
          margin-top: 6rem;
          width: 8.5rem;
          height: 3rem;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #1774f5;
          color: #fff;
        }
      }
    }
    .product-box1 {
      display: none;
    }
    .product-box {
      width: 80%;
      margin: 1.5rem auto;

      .mol-header {
        padding: 0.6rem;
        .title {
          font-size: 2.2rem;
          font-weight: 500;
          color: #000;
          margin-bottom: 0.6rem;
        }
        .line {
          width: 3.5rem;
          // color: #1774f5;
          border: 0.15rem solid #1774f5;
          background-color: #1774f5;
        }
      }
      .center-header {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: 4rem;
      }
      .left-header {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 2rem;
        padding-left: 10px;
      }
      .content {
        width: 100%;
        .row {
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin: 1.2rem 0 0;
          flex-wrap: wrap;

          .col1 {
            // width: 902px;
            // height: 446px;
            height: 100%;
            max-height: 34rem;
            margin: 0 1rem 0;
          }
          .col2 {
            // width: 446px;
            height: 100%;
            max-height: 34rem;
            margin: 0 1rem 0;
            // padding-bottom: 20px;
            // box-sizing: border-box;
          }
          .col {
            // width: 100%;
            height: 100%;
            margin: 0 1rem;
            box-sizing: border-box;
          }
          .col3 {
            // width: 31.5rem;
            height: 32rem;
            background-color: #f2f2f2;
            position: relative;
            .top-tip {
              position: absolute;
              width: 4.3rem;
              height: 2rem;
              background-color: #858a90;
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: center;
              z-index: 1;
            }
            .pic {
              height: 20rem;
              .el-image {
                width: 100%;
              }
            }
            .desc {
              width: 100%;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              .desc-title {
                text-align: left;
                cursor: pointer;
                font-weight: 600;
                font-size: 1.2rem;
                padding: 2rem 2rem 0.5rem;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                box-sizing: border-box;
              }
              .desc-info {
                display: flex;
                align-items: center;
                color: #424242;
                font-size: 1rem;
                padding: 0 2rem;
                .info-time {
                  margin-left: 1.2rem;
                }
              }
              .desc-end {
                text-align: left;
                color: #6e6e6e;
                font-size: 1rem;
                padding: 1rem 2rem;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                box-sizing: border-box;
              }
            }
            .news-list {
              width: 100%;
              height: 100%;
              // overflow-y: auto;
              padding: 2.5rem 0 2rem 2rem;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;

              .news-item {
                padding-right: 2rem;
                text-align: left;
                height: 4.65rem;
                flex-shrink: 0;
                .news-title {
                  cursor: pointer;
                  width: 100%;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  line-height: 2;
                  font-weight: 600;
                  font-size: 1.2rem;
                }
                .news-time {
                  color: #6e6e6e;
                  font-size: 1rem;
                }
              }
            }
          }
        }

      }
    }
    .body-banner {
      width: 100%;
      height: 57rem;
      margin: 3rem 0;
      position: relative;
      // background-image: url('@/assets/1.jpg');
      // background-repeat: no-repeat;
      // background-size: cover;
      .banner-text {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        text-align: left;
        padding-top: 18rem;
        padding-left: 14rem;
        box-sizing: border-box;
        .bold-txt {
          font-weight: 550;
          font-size: 3.2rem;
          width: 50%;
          margin-bottom: 2.5rem;
        }
        .thin-txt {
          margin-top: 2.5rem;
          font-size: 1.6rem;
          width: 50%;
        }
        .line {
          width: 14rem;
          border: 0.15rem solid #1774f5;
          background-color: #1774f5;
          margin-top: 1.5rem;
        }
        .btn {
          cursor: pointer;
          margin-top: 2.5rem;
          width: 8.5rem;
          height: 3rem;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #1774f5;
          color: #fff;
        }
      }
    }
    .more {
      width: 25rem;
      margin: 4rem auto;
      display: flex;
      justify-content: space-evenly;
      .more-btn {
        cursor: pointer;
        width: 8rem;
        height: 2.5rem;
        color: #4e4e4e;
        border: 1px solid #8b8b8b;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1rem;
      }
    }
    .tab-imgBox{
      border-radius: 10px;
    }
    .imgBox:hover {
      .el-image {
        transform: scale(1.1);
        transition: all 0.5s linear;
      }
      .imgDesc {
        transform: translateY(-3rem);
      }
    }
    .imgBox {
      overflow: hidden;
      position: relative;
      cursor: pointer;
      .el-image {
        transition: all 0.5s linear;
      }
      .imgDesc {
        position: absolute;
        left: 1.5rem;
        bottom: -2rem;
        color: #fff;
        text-align: left;
        line-height: 2;
        transition: all 0.5s linear;
        width: 100%;
        .title {
          font-size: 1.4rem;
          font-weight: 600;
        }
        .pro-desc{
          width: 90%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .know-more {
          margin-top: 0.8rem;
          cursor: pointer;
        }
      }
      .norDesc {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        text-align: left;
        padding: 5rem 8rem;
        box-sizing: border-box;
        color:#fff;

        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        .bold-txt {
          font-weight: 550;
          font-size: 2.8rem;
          width: 50%;
          // margin-bottom: 2.5rem;
        }
        .thin-txt {
          margin: 2rem 0;
          font-size: 1.4rem;
          width: 50%;
        }
        .line {
          width: 14rem;
          border: 0.15rem solid #1774f5;
          background-color: #1774f5;
          margin-top: 1.5rem;
        }
        .btn {
          cursor: pointer;
          // margin-top: 2.5rem;
          width: 8.5rem;
          height: 3rem;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #1774f5;
          color: #fff;
        }

      }
    }
    .el-row {
      width: 100%;
      margin: 0 !important;
    }
    .el-col {
      margin-bottom: 2rem;
    }
  }
}
.home2 {
  min-height: calc(100vh - 36rem);
  padding-top: 4rem;
  // padding-bottom: 30rem;
  position: relative;
  .home-page {
    width: 100%;
    margin: 0 auto;
    // min-width: 1440px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .lunbo {
      width: 100%;
      // height: 720px;
      height: 30rem;
      position: relative;
      margin-bottom: 1rem;
      .swiper-container {
        width: 100%;
        height: 100%;
      }
      .el-carousel {
        width: 100%;
        height: 100%;
      }
      .banner-lunbo {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        text-align: center;
        padding-top: 4rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        .bold-txt {
          font-weight: bold;
          font-size: 2rem;
        }
        .thin-txt {
          margin-top: 2rem;
          font-size: 1.2rem;
        }
        .line {
          width: 14rem;
          border: 0.15rem solid #1774f5;
          background-color: #1774f5;
          margin-top: 1.5rem;
        }
        .btn {
          cursor: pointer;
          margin-top: 6rem;
          width: 8.5rem;
          height: 3rem;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #1774f5;
          color: #fff;
          display: none;
        }
      }
    }
    .product-box {
      display: none;
    }
    .product-box1 {
      width: 100%;
      padding: 1rem;
      box-sizing: border-box;
      .mol-header {
        padding: 0.6rem;
        .title {
          font-size: 2rem;
          font-weight: 500;
          color: #000;
          margin-bottom: 0.6rem;
        }
        .line {
          width: 3.5rem;
          // color: #1774f5;
          border: 0.15rem solid #1774f5;
          background-color: #1774f5;
        }
      }
      .center-header {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: 2rem;
      }
      .left-header {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 2rem;
        padding-left: 10px;
      }
      .content {
        width: 100%;
        display: flex;
        flex-direction: column;
        .row {
          width: 100%;
          display: flex;
          justify-content: space-between;
          // margin: 1.2rem 0 0;
          padding: 1rem 0 0;
          flex-wrap: wrap;
          box-sizing: border-box;

          .col {
            // width: 100%;
            height: 12rem;
            margin: 0 0.5rem;
            // margin: 0 1rem;
            box-sizing: border-box;
          }

          .col3 {
            // width: 31.5rem;
            height: 22rem;
            background-color: #f2f2f2;
            position: relative;
            .top-tip {
              position: absolute;
              width: 4.3rem;
              height: 2rem;
              background-color: #858a90;
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: center;
              z-index: 1;
            }
            .pic {
              height: 14rem;
              .el-image {
                width: 100%;
              }
            }
            .desc {
              height: 8rem;
              width: 100%;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              .desc-title {
                text-align: left;
                cursor: pointer;
                font-size: 1rem;
                font-weight: 500;
                padding: 1rem 1rem 0.5rem;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                box-sizing: border-box;
              }
              .desc-info {
                display: flex;
                align-items: center;
                color: #424242;
                font-size: 0.9rem;
                padding: 0 1rem;

                .info-time {
                  margin-left: 1.2rem;
                }
              }
              .desc-end {
                text-align: left;
                color: #6e6e6e;
                font-size: 0.9rem;
                padding: 1rem 1rem;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                box-sizing: border-box;
              }
            }
            .news-list {
              width: 100%;
              height: 100%;
              // overflow-y: auto;
              padding: 2rem 0 2rem 1rem;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;

              .news-item {
                padding-right: 2rem;
                text-align: left;
                height: 3.7rem;
                flex-shrink: 0;
                .news-title {
                  cursor: pointer;
                  width: 100%;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  line-height: 2;
                  font-weight: 600;
                  font-size: 1rem;
                }
                .news-time {
                  color: #6e6e6e;
                  font-size: 0.9rem;
                }
              }
            }
          }
          .news-col{
            height: 25.2rem;
          }
        }
        .lunbo2 {
          width: 100%;
          height: 20rem;
          padding: 0 0.5rem;
          box-sizing: border-box;
          position: relative;
          .swiper-container {
            width: 100%;
            height: 100%;
          }
          .el-carousel {
            width: 100%;
            height: 100%;
          }

          .imgDesc {
            position: absolute;
            left: 1.5rem;
            bottom: 2rem;
            color: #fff;
            text-align: left;
            line-height: 1.5;
            padding-right: 1rem;
            .title {
              font-size: 1.1rem;
            }
          }
        }
      }
    }
    .body-banner {
      width: 100%;
      height: 30rem;
      margin: 2rem 0;
      position: relative;
      // background-image: url('@/assets/1.jpg');
      // background-repeat: no-repeat;
      // background-size: cover;
      .banner-text {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        text-align: left;
        padding: 4rem 2rem;
        box-sizing: border-box;
        .bold-txt {
          font-weight: bold;
          font-size: 1.4rem;
        }
        .thin-txt {
          margin-top: 2.5rem;
          font-size: 1rem;
        }
        .line {
          width: 10rem;
          border: 0.15rem solid #1774f5;
          background-color: #1774f5;
          margin-top: 1.5rem;
        }
        .btn {
          cursor: pointer;
          margin-top: 2.5rem;
          width: 6rem;
          height: 2rem;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #1774f5;
          color: #fff;
          font-size: 0.8rem;
        }
      }
    }
    .more {
      width: 20rem;
      margin: 3rem auto;
      display: flex;
      justify-content: space-evenly;
      .more-btn {
        cursor: pointer;
        width: 7rem;
        height: 2rem;
        color: #4e4e4e;
        border: 1px solid #8b8b8b;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.8rem;
      }
    }
    .imgBox:hover {
      .el-image {
        transform: scale(1.1);
        transition: all 0.5s linear;
      }
      .imgDesc {
        transform: translateY(-3rem);
      }
    }
    .imgBox {
      overflow: hidden;
      position: relative;
      cursor: pointer;
      .el-image {
        transition: all 0.5s linear;
      }
      .imgDesc {
        position: absolute;
        left: 1.5rem;
        bottom: -2rem;
        color: #fff;
        text-align: left;
        line-height: 2;
        transition: all 0.5s linear;
        .title {
          font-size: 1.4rem;
          font-weight: 600;
        }
        .know-more {
          margin-top: 0.8rem;
          cursor: pointer;
        }
      }
      .norDesc {
        position: absolute;
        left: 0;
        bottom: 1rem;
        padding: 0.5rem;
        color: #fff;
        text-align: left;
        line-height: 1.5;
        font-size: 0.8rem;
      }
    }
    .el-row {
      width: 100%;
      margin: 0 !important;
    }
    .el-col {
      margin-bottom: 1rem;
    }
  }
}
</style>
